module.exports = __webpack_public_path__ + "img/dashboard-admin-active.9b352cd3.svg";